import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fit text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close icon-xs p-0 mb-4",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_column = _resolveComponent("v-form-column")!
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formStructure.form_groups, (formGroupStructure, index) => {
    return (_openBlock(), _createElementBlock("tr", { key: index }, [
      _createVNode(_component_v_form_column, {
        "form-group-structure": formGroupStructure,
        "form-group-data": _ctx.formGroup,
        "form-type": _ctx.formType,
        "form-id": _ctx.formId,
        "force-save": _ctx.forceSave,
        "action-buttons": _ctx.actionButtons,
        "input-class": _ctx.inputClass,
        "suffix-class": _ctx.suffixClass,
        "prefix-class": _ctx.prefixClass,
        "adjust-input-for-value": _ctx.adjustInputForValue,
        onUpdateFormGroupRequest: _ctx.updateFormGroup,
        "onOldValue:value": _ctx.saveOldValue
      }, null, 8, ["form-group-structure", "form-group-data", "form-type", "form-id", "force-save", "action-buttons", "input-class", "suffix-class", "prefix-class", "adjust-input-for-value", "onUpdateFormGroupRequest", "onOldValue:value"]),
      _createElementVNode("td", _hoisted_1, [
        (_ctx.can('professional.expedient.form.destroy'))
          ? (_openBlock(), _createBlock(_component_v_button, {
              key: 0,
              variant: "icon",
              class: "d-flex flex-column p-8 m-auto",
              "aria-label": _ctx.$t('Eliminar registro'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete-form-group-request', _ctx.formGroup.id)))
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Borrar')), 1)
              ]),
              _: 1
            }, 8, ["aria-label"]))
          : _createCommentVNode("", true)
      ])
    ]))
  }), 128))
}